var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchToDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.407,
    height: 50.859,
    viewBox: "0 0 69.407 50.859",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28733",
    "data-name": "Group 28733",
    transform: "translate(984.997 18434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "desktop",
    transform: "translate(-968.805 -18445)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51667",
    "data-name": "Path 51667",
    d: "M163.445,401l-9.009,3.212-.342,1.194A4.519,4.519,0,0,1,150,408.5v.8h18.684Z",
    transform: "translate(-133.939 -348.242)",
    fill: "#a7a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51668",
    "data-name": "Path 51668",
    d: "M203.993,378.618l-1.259-4.406L197.541,371l-5.193,3.212-.918,3.212h9.009l.342,1.194a4.519,4.519,0,0,0,4.094,3.089l1.606.8,1.606-.8A4.519,4.519,0,0,1,203.993,378.618Z",
    transform: "translate(-170.933 -321.454)",
    fill: "#a7a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51669",
    "data-name": "Path 51669",
    d: "M437,267.061h3.212a3.222,3.222,0,0,0,3.212-3.212v-6.424L437,251Z",
    transform: "translate(-390.209 -214.303)",
    fill: "#adaca7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51670",
    "data-name": "Path 51670",
    d: "M0,210.273a3.33,3.33,0,0,0,3.419,3.212H49.8a3.33,3.33,0,0,0,3.419-3.212V191L0,203.849Z",
    transform: "translate(0 -160.727)",
    fill: "#cbc9c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51671",
    "data-name": "Path 51671",
    d: "M440.212,11H437l3.212,32.122h3.212V14.212A3.222,3.222,0,0,0,440.212,11Z",
    transform: "translate(-390.209)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51672",
    "data-name": "Path 51672",
    d: "M50,14.212A3.222,3.222,0,0,0,46.791,11H3.212A3.222,3.222,0,0,0,0,14.212v28.91H50V39.91l-23.4-12.85Z",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51673",
    "data-name": "Path 51673",
    d: "M271.9,40.976l-3.212,0L248.5,53.824l20.183,12.85,3.212,0S271.895,40.977,271.9,40.976Z",
    transform: "translate(-221.892 -26.765)",
    fill: "#4b88d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51674",
    "data-name": "Path 51674",
    d: "M76.791,40.975l-46.78,0S30,66.673,30,66.673l46.789,0S76.786,40.976,76.791,40.975Z",
    transform: "translate(-26.788 -26.764)",
    fill: "#e5f3f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1506",
    "data-name": "Ellipse 1506",
    cx: 1.606,
    cy: 1.606,
    r: 1.606,
    transform: "translate(25.001 46.334)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51675",
    "data-name": "Path 51675",
    d: "M120,472.606H86.8a.8.8,0,0,1,0-1.606H120a.8.8,0,0,1,0,1.606Z",
    transform: "translate(-76.792 -410.747)",
    fill: "#c5c1bb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iphone",
    transform: "translate(-1061.32 -18426.281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51680",
    "data-name": "Path 51680",
    d: "M205.473,0h-14.5a3.912,3.912,0,0,0-3.863,3.951V38.289a3.912,3.912,0,0,0,3.863,3.951h14.5a3.912,3.912,0,0,0,3.863-3.951V3.951A3.912,3.912,0,0,0,205.473,0Z",
    transform: "translate(-110.783 0.9)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51682",
    "data-name": "Path 51682",
    d: "M232.732,64.079a1.833,1.833,0,0,1-1.832,1.833H215.473a1.833,1.833,0,0,1-1.833-1.833V28.366a1.833,1.833,0,0,1,1.833-1.833H217.4a.686.686,0,0,1,.686.686v.435a1.064,1.064,0,0,0,1.061,1.061h8.088a1.064,1.064,0,0,0,1.061-1.061v-.629a.492.492,0,0,1,.492-.492H230.9a1.833,1.833,0,0,1,1.832,1.833Z",
    transform: "translate(-135.748 -24.202)",
    fill: "#cae1de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51689",
    "data-name": "Path 51689",
    d: "M241.3,88.96h-1.774a.3.3,0,0,1-.3-.3V86.89a.3.3,0,0,1,.3-.3H241.3a.3.3,0,0,1,.3.3v1.774A.3.3,0,0,1,241.3,88.96Z",
    transform: "translate(-159.146 -79.11)",
    fill: "#70b5e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51690",
    "data-name": "Path 51690",
    d: "M289.982,88.96h-1.774a.3.3,0,0,1-.3-.3V86.89a.3.3,0,0,1,.3-.3h1.774a.3.3,0,0,1,.3.3v1.774A.3.3,0,0,1,289.982,88.96Z",
    transform: "translate(-203.647 -79.11)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51691",
    "data-name": "Path 51691",
    d: "M338.658,88.96h-1.774a.3.3,0,0,1-.3-.3V86.89a.3.3,0,0,1,.3-.3h1.774a.3.3,0,0,1,.3.3v1.774A.3.3,0,0,1,338.658,88.96Z",
    transform: "translate(-248.146 -79.11)",
    fill: "#92b620"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51692",
    "data-name": "Path 51692",
    d: "M387.334,88.96H385.56a.3.3,0,0,1-.3-.3V86.89a.3.3,0,0,1,.3-.3h1.774a.3.3,0,0,1,.3.3v1.774A.3.3,0,0,1,387.334,88.96Z",
    transform: "translate(-292.645 -79.11)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51693",
    "data-name": "Path 51693",
    d: "M241.3,138.116h-1.774a.3.3,0,0,1-.3-.3v-1.774a.3.3,0,0,1,.3-.3H241.3a.3.3,0,0,1,.3.3v1.774A.3.3,0,0,1,241.3,138.116Z",
    transform: "translate(-159.146 -124.049)",
    fill: "#92b620"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51694",
    "data-name": "Path 51694",
    d: "M289.982,138.116h-1.774a.3.3,0,0,1-.3-.3v-1.774a.3.3,0,0,1,.3-.3h1.774a.3.3,0,0,1,.3.3v1.774A.3.3,0,0,1,289.982,138.116Z",
    transform: "translate(-203.647 -124.049)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51695",
    "data-name": "Path 51695",
    d: "M338.658,138.116h-1.774a.3.3,0,0,1-.3-.3v-1.774a.3.3,0,0,1,.3-.3h1.774a.3.3,0,0,1,.3.3v1.774A.3.3,0,0,1,338.658,138.116Z",
    transform: "translate(-248.146 -124.049)",
    fill: "#70b5e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51696",
    "data-name": "Path 51696",
    d: "M387.334,138.116H385.56a.3.3,0,0,1-.3-.3v-1.774a.3.3,0,0,1,.3-.3h1.774a.3.3,0,0,1,.3.3v1.774A.3.3,0,0,1,387.334,138.116Z",
    transform: "translate(-292.645 -124.049)",
    fill: "#f94a46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51697",
    "data-name": "Path 51697",
    d: "M241.3,187.911h-1.774a.3.3,0,0,1-.3-.3v-1.774a.3.3,0,0,1,.3-.3H241.3a.3.3,0,0,1,.3.3v1.774A.3.3,0,0,1,241.3,187.911Z",
    transform: "translate(-159.146 -169.571)",
    fill: "#dda36f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51698",
    "data-name": "Path 51698",
    d: "M289.982,187.911h-1.774a.3.3,0,0,1-.3-.3v-1.774a.3.3,0,0,1,.3-.3h1.774a.3.3,0,0,1,.3.3v1.774A.3.3,0,0,1,289.982,187.911Z",
    transform: "translate(-203.647 -169.571)",
    fill: "#f9d698"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51699",
    "data-name": "Path 51699",
    d: "M338.658,187.911h-1.774a.3.3,0,0,1-.3-.3v-1.774a.3.3,0,0,1,.3-.3h1.774a.3.3,0,0,1,.3.3v1.774A.3.3,0,0,1,338.658,187.911Z",
    transform: "translate(-248.146 -169.571)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51700",
    "data-name": "Path 51700",
    d: "M387.334,187.911H385.56a.3.3,0,0,1-.3-.3v-1.774a.3.3,0,0,1,.3-.3h1.774a.3.3,0,0,1,.3.3v1.774A.3.3,0,0,1,387.334,187.911Z",
    transform: "translate(-292.645 -169.571)",
    fill: "#f9d698"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28731",
    "data-name": "Group 28731",
    transform: "translate(80.089 20.193)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51701",
    "data-name": "Path 51701",
    d: "M241.3,237.067h-1.774a.3.3,0,0,1-.3-.3V235a.3.3,0,0,1,.3-.3H241.3a.3.3,0,0,1,.3.3v1.774A.3.3,0,0,1,241.3,237.067Z",
    transform: "translate(-239.235 -234.702)",
    fill: "#70b5e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51702",
    "data-name": "Path 51702",
    d: "M289.982,237.067h-1.774a.3.3,0,0,1-.3-.3V235a.3.3,0,0,1,.3-.3h1.774a.3.3,0,0,1,.3.3v1.774A.3.3,0,0,1,289.982,237.067Z",
    transform: "translate(-283.735 -234.702)",
    fill: "#70b5e8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_51703",
    "data-name": "Path 51703",
    d: "M338.658,237.067h-1.774a.3.3,0,0,1-.3-.3V235a.3.3,0,0,1,.3-.3h1.774a.3.3,0,0,1,.3.3v1.774A.3.3,0,0,1,338.658,237.067Z",
    transform: "translate(-248.146 -214.509)",
    fill: "#f94a46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51704",
    "data-name": "Path 51704",
    d: "M241.3,286.223h-1.774a.3.3,0,0,1-.3-.3v-1.774a.3.3,0,0,1,.3-.3H241.3a.3.3,0,0,1,.3.3v1.774A.3.3,0,0,1,241.3,286.223Z",
    transform: "translate(-159.146 -259.448)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51705",
    "data-name": "Path 51705",
    d: "M289.982,286.223h-1.774a.3.3,0,0,1-.3-.3v-1.774a.3.3,0,0,1,.3-.3h1.774a.3.3,0,0,1,.3.3v1.774A.3.3,0,0,1,289.982,286.223Z",
    transform: "translate(-203.647 -259.448)",
    fill: "#92b620"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51706",
    "data-name": "Path 51706",
    d: "M338.658,286.223h-1.774a.3.3,0,0,1-.3-.3v-1.774a.3.3,0,0,1,.3-.3h1.774a.3.3,0,0,1,.3.3v1.774A.3.3,0,0,1,338.658,286.223Z",
    transform: "translate(-248.146 -259.448)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51707",
    "data-name": "Path 51707",
    d: "M387.334,237.067H385.56a.3.3,0,0,1-.3-.3V235a.3.3,0,0,1,.3-.3h1.774a.3.3,0,0,1,.3.3v1.774A.3.3,0,0,1,387.334,237.067Z",
    transform: "translate(-292.645 -214.509)",
    fill: "#ffb70d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51708",
    "data-name": "Path 51708",
    d: "M241.306,437.892h-1.774a.3.3,0,0,1-.3-.3v-1.774a.3.3,0,0,1,.3-.3h1.774a.3.3,0,0,1,.3.3V437.6A.3.3,0,0,1,241.306,437.892Z",
    transform: "translate(-159.147 -398.103)",
    fill: "#92b620"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51709",
    "data-name": "Path 51709",
    d: "M289.982,437.892h-1.774a.3.3,0,0,1-.3-.3v-1.774a.3.3,0,0,1,.3-.3h1.774a.3.3,0,0,1,.3.3V437.6A.3.3,0,0,1,289.982,437.892Z",
    transform: "translate(-203.647 -398.103)",
    fill: "#70b5e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51710",
    "data-name": "Path 51710",
    d: "M338.658,437.892h-1.774a.3.3,0,0,1-.3-.3v-1.774a.3.3,0,0,1,.3-.3h1.774a.3.3,0,0,1,.3.3V437.6A.3.3,0,0,1,338.658,437.892Z",
    transform: "translate(-248.146 -398.103)",
    fill: "#92b620"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51711",
    "data-name": "Path 51711",
    d: "M387.334,437.892H385.56a.3.3,0,0,1-.3-.3v-1.774a.3.3,0,0,1,.3-.3h1.774a.3.3,0,0,1,.3.3V437.6A.3.3,0,0,1,387.334,437.892Z",
    transform: "translate(-292.645 -398.103)",
    fill: "#efefef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "down-arrow",
    transform: "translate(-968.805 -18362.926) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28732",
    "data-name": "Group 28732",
    transform: "translate(43.464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51712",
    "data-name": "Path 51712",
    d: "M55.38,8.479a.457.457,0,0,0-.329-.138H52.639A.341.341,0,0,1,52.3,8V.457A.457.457,0,0,0,51.842,0h-4.7a.457.457,0,0,0-.457.457V8a.341.341,0,0,1-.341.341H43.93a.457.457,0,0,0-.327.784l5.561,5.561a.453.453,0,0,0,.647,0l5.561-5.561A.457.457,0,0,0,55.38,8.479Z",
    transform: "translate(-43.464)",
    fill: "#ea555f"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchToDesktop);
export default __webpack_public_path__ + "static/media/switch-to-desktop.9228ef5c42186b3ba55a02d48189bb99.svg";
export { ForwardRef as ReactComponent };